import { selectorFamily } from "recoil";
import { layerDefsAtomFamily } from "../layerDefsAtoms";

export const layerDefPointSizeSelector = selectorFamily({
  key: "layer-point-size-selector",
  get:
    (layerID) =>
    ({ get }) => {
      const { layer } = get(layerDefsAtomFamily(layerID));
      if (layer.type === "circle") {
        return layer.paint["circle-radius"];
      }
    },
  set:
    (layerID) =>
    ({ set }, newPointSize) => {
      set(layerDefsAtomFamily(layerID), (oldLayer) => {
        if (oldLayer.layer.type !== "circle") {
          return oldLayer;
        }

        return {
          ...oldLayer,
          layer: {
            ...oldLayer.layer,
            paint: {
              ...oldLayer.layer?.paint,
              "circle-radius": newPointSize,
            },
          },
        };
      });
    },
});
